import { render, staticRenderFns } from "./CarreraPolicialComponent.vue?vue&type=template&id=8bc1d1ee&scoped=true"
import script from "./CarreraPolicialComponent.vue?vue&type=script&lang=js"
export * from "./CarreraPolicialComponent.vue?vue&type=script&lang=js"
import style0 from "./CarreraPolicialComponent.vue?vue&type=style&index=0&id=8bc1d1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc1d1ee",
  null
  
)

export default component.exports